import { render } from "./Pbx3cxQueuePreanswerTimeConfiguration.vue?vue&type=template&id=8286dde6"
import script from "./Pbx3cxQueuePreanswerTimeConfiguration.vue?vue&type=script&lang=js"
export * from "./Pbx3cxQueuePreanswerTimeConfiguration.vue?vue&type=script&lang=js"

import "./Pbx3cxQueuePreanswerTimeConfiguration.vue?vue&type=style&index=0&id=8286dde6&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__